import React from "react";
import Layout from "../../components/organisms/Layout";
import Details from "../../components/pages/product-detail/Details";
import Insurance from "../../components/molecules/InsuranceList";
import IMG from "../../assets/images/product-detail/company/VIDA_GRUPO.png";
import { DetailWithImage } from "../../components/pages/quote/DetailWithImage";
import Technology from "../../components/pages/product-detail/Technology";

const VidaGrupo = ({}) => {
	return (
		<Layout landingPage='company'>
			<Details type={"vida-grupo"} title={"Seguro para Vida Grupo"} />
			<DetailWithImage
				title={
					<h1>
						Protegiendo <span className='text-primary'>a los tuyos.</span>
					</h1>
				}
				content='Protege a tus empleados en caso de invalidez por accidente y a sus familias en caso de que llegaran a faltar, mientras obtienes importantes beneficios para tu negocio.'
				image={IMG}
			/>
			<Technology />
			<Insurance
				type='company'
				current='vida-grupo'
				title='Una amplia gama de seguros'
			/>
		</Layout>
	);
};
export default VidaGrupo;
